export default "__VITE_ASSET__FhhQ9Edq__"